<template>
	<header class="header">
		<div class="header-inner">
			<div class="logo" @click="goHome">
				<img :src="logoImg" class="logo" alt="Logo" />
			</div>
			<div class="header-home" @click="goHome">
				首页
			</div>
			<nav class="nav">
				<ul class="nav-list">
					<li v-for="menu in menuTree" :key="menu.menuId" class="nav-item"
						:class="{ active: activeMenuId === menu.menuId }" @click="handleMenuClick(menu)">
						<span class="nav-text">{{ menu.menuName }}</span>
						<span class="nav-indicator"></span>
						<div v-if="menu.children && menu.children.length" class="dropdown-panel"
							@mouseleave="mouseupMenu">
							<div class="dropdown-container">
								<div v-for="child in menu.children" :key="child.menuId" class="menu-card"
									@mousemove="setActiveMenu(child.children)">
									<div class="menu-card-header">
										<span class="menu-icon">
											<!-- <img v-if="child.image" :src="child.image" class="menu-icon-img" /> -->
											<svg viewBox="0 0 24 24" width="20" height="20" fill="none"
												stroke="#4a90e2">
												<circle cx="12" cy="12" r="3" />
												<path d="M12 2v4" />
												<path d="M12 18v4" />
											</svg>
										</span>
										<span class="menu-title" @click="handleLevel2Click(child, menu)">
											{{ child.menuName }}
										</span>
									</div>

								</div>
							</div>
							<ul v-if="childrenList && childrenList.length" class="menu-sub-list"
								@mouseleave="mouseupMenu">
								<li v-for="sub in childrenList" :key="sub.menuId" class="menu-sub-item"
									@click.stop="handleSubMenuClick(sub)">
									{{ sub.menuName }}
								</li>
							</ul>
						</div>
					</li>
				</ul>
			</nav>

			<div class="search">
				<img :src="searchImg" class="search" alt="Search" />
			</div>
		</div>
	</header>
</template>

<script setup>
	import {
		ref,
		onMounted
	} from 'vue'
	import {
		useRouter,
		useRoute
	} from 'vue-router'
	import {
		getMenuTree
	} from '@/api/website'
	import logoImg from '@/assets/log.png'
	import searchImg from '@/assets/search.png'

	defineProps({
		introLinkUrl: {
			type: String,
			default: ''
		}
	})

	const router = useRouter()
	const route = useRoute()
	const menuTree = ref([])
	const activeMenuId = ref(null)
	const childrenList = ref([])
	const setActiveMenu = (menu) => {
		childrenList.value = menu
	}

	const mouseupMenu = (menu) => {
		childrenList.value = []
	}
	const handleSubMenuClick = (sub) => {
		if (sub.url) {
			const path = getMenuPath(sub)
			const url = new URL(sub.url, window.location.origin)
			if (path.length > 1) {
				url.searchParams.set('menuPath', JSON.stringify(path))
			}
			router.push(url.pathname + url.search)
		}
	}
	const getMenuPath = (menu) => {
		const path = []
		let currentMenu = menu
		while (currentMenu) {
			path.unshift({ menuId: currentMenu.menuId, menuName: currentMenu.menuName, url: currentMenu.url })
			if (currentMenu.parentId && currentMenu.parentId !== 0) {
				currentMenu = findMenuById(currentMenu.parentId)
			} else {
				currentMenu = null
			}
		}
		return path
	}
	const findMenuById = (menuId) => {
		for (const menu of menuTree.value) {
			if (menu.menuId === menuId) {
				return menu
			}
			if (menu.children) {
				const found = findMenuInChildren(menu.children, menuId)
				if (found) return found
			}
		}
		return null
	}
	const findMenuInChildren = (children, menuId) => {
		for (const child of children) {
			if (child.menuId === menuId) {
				return child
			}
			if (child.children) {
				const found = findMenuInChildren(child.children, menuId)
				if (found) return found
			}
		}
		return null
	}
	const handleMenuClick2 = (menu) => {
		if (menu.url) {
			const path = getMenuPath(menu)
			const url = new URL(menu.url, window.location.origin)
			if (path.length > 1) {
				url.searchParams.set('menuPath', JSON.stringify(path))
			}
			router.push(url.pathname + url.search)
		}
	}
	
	// 点击一级菜单，跳转到菜单列表页
	const handleMenuClick = (menu) => {
		if(menu.menuName=="关于我们"){
			router.push('/about')
			return
		}
		activeMenuId.value = menu.menuId
		// 如果没有二级菜单，不跳转
		if (!menu.children || menu.children.length === 0) {
			return
		}
		router.push({
			path: '/menu',
			query: {
				menuId: menu.menuId
			}
		})
	}

	// 点击二级菜单标题，跳转到菜单列表页并选中该二级
	const handleLevel2Click = (child, parentMenu) => {
		router.push({
			path: '/menu',
			query: {
				menuId: parentMenu.menuId,
				level2Id: child.menuId
			}
		})
	}

	const goHome = () => {
		activeMenuId.value = null
		router.push('/')
	}

	const loadData = async () => {
		try {
			const res = await getMenuTree()
			if (res.code === 200 && res.data) {
				menuTree.value = res.data
			}
		} catch (error) {
			console.error('加载菜单失败:', error)
		}
	}

	onMounted(() => {
		loadData()
	})
</script>

<style scoped>
	.header-home {
		width: 49px;
		font-size: 22px;
		font-weight: 550;
		color: #333;
		margin-left: 80px;
		transition: all 0.2s;
		cursor: pointer;
		box-sizing: border-box;
	}

	.header-home:hover {
		color: #4a90e2;
	}

	.header {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		height: 100px;
		background: #fff;
		z-index: 1000;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
	}

	.header-inner {
		width: 100%;
		margin: 0 auto;
		height: 100%;
		display: flex;
		align-items: center;
		padding: 0 60px;
	}

	.logo {
		display: block;
		width: 88px;
		height: 80px;
		cursor: pointer;
	}

	.logo img {
		width: 100%;
		height: 100%;
	}

	.nav {
		width: 90%;
	}

	.nav-list {
		display: flex;
		list-style: none;
		margin-left: 28px;
		gap: 0;
	}

	.nav-item {
		position: relative;
		font-size: 22px;
		font-weight: 550;
		color: #333;
		padding: 36px 32px;
		transition: all 0.3s;
		cursor: pointer;
	}

	.nav-text {
		position: relative;
		z-index: 1;
	}

	.nav-indicator {
		position: absolute;
		bottom: 30px;
		left: 50%;
		transform: translateX(-50%);
		width: 0;
		height: 3px;
		background: linear-gradient(90deg, #4a90e2, #357abd);
		border-radius: 2px;
		transition: width 0.3s;
	}

	.nav-item:hover {
		color: #4a90e2;
	}

	.nav-item:hover .nav-indicator {
		width: 60%;
	}

	.nav-item.active {
		color: #4a90e2;
	}

	.nav-item.active .nav-indicator {
		width: 60%;
	}

	.dropdown-panel {
		display: none;
		position: fixed;
		top: 100px;
		left: 0;
		right: 0;
		background: #fff;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
		z-index: 1001;
	}

	.nav-item:hover .dropdown-panel {
		display: block;
	}

	.dropdown-container {
		display: flex;
		gap: 30px;
		margin: 0 auto;
		padding: 0 10px 0 170px;
		overflow-x: auto;
		scrollbar-width: thin;
		scrollbar-color: #F0F8FF transparent;
	}

	.menu-card {
		min-width: 105px;
		padding: 15px 0 5px 0;
	}

	.menu-card-header {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-bottom: 16px;
	}

	.menu-icon-img {
		width: 20px;
		height: 20px;
		object-fit: contain;
	}

	.menu-title {
		font-size: 16px;
		font-weight: 500;
		color: #333;
		cursor: pointer;
	}

	.menu-title:hover {
		color: #4a90e2;
	}

	.menu-sub-list {
		list-style: none;
		padding-left: 26px;
		max-height: 60vh;
		overflow-y: auto;
		display: flex;
		flex-wrap: wrap;
		scrollbar-width: thin;
		scrollbar-color: #F0F8FF transparent;
	}

	.menu-sub-item {
		font-size: 15px;
		color: #666;
		padding: 5px 0;
		cursor: pointer;
		line-height: 1.6;
		margin: 5px 20px 20px 20px;
	}

	.menu-sub-item:hover {
		color: #4a90e2;
	}

	.search {
		cursor: pointer;
		width: 30px;
		height: 28px;
		display: block;
	}

	.search img {
		width: 100%;
		height: 100%;
	}
</style>